export enum IdealPaymentStatusEnum {
  OPEN = 'OPEN',
  IDENTIFIED = 'IDENTIFIED',
  SUCCESS = 'SUCCESS',
  CANCELLED = 'CANCELLED',
  FAILURE = 'FAILURE',
  ERROR = 'ERROR',
}
